module.exports = __webpack_public_path__ + "img/canAttach.7340a549.svg";